import { render, staticRenderFns } from "./OrderWorkerModal.vue?vue&type=template&id=cd4631d2&scoped=true"
import script from "./OrderWorkerModal.vue?vue&type=script&lang=ts"
export * from "./OrderWorkerModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderWorkerModal.vue?vue&type=style&index=0&id=cd4631d2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4631d2",
  null
  
)

export default component.exports